import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';

export default function PublicHeader() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    window.scrollTo(0, 0);
    navigate(path);
  };

  return (
    <header className="public-header">
      <div className="header-content">
        <div className="logo" onClick={() => handleNavigate('/')}>
          <img src={logo} alt="Hangrily" className="logo-image" />
        </div>
        <nav className="header-nav">
          <Link to="/how-it-works" onClick={() => window.scrollTo(0, 0)}>How It Works</Link>
          <Link to="/features" onClick={() => window.scrollTo(0, 0)}>Features</Link>
          <Link to="/faq" onClick={() => window.scrollTo(0, 0)}>FAQ</Link>
          <Link to="/blog" onClick={() => window.scrollTo(0, 0)}>Blog</Link>
          <Link to="/try" className="btn btn-primary" onClick={() => window.scrollTo(0, 0)} style={{ marginRight: '8px' }}>
            Try Free
          </Link>
          <button className="btn btn-secondary" onClick={() => handleNavigate('/login')}>
            Sign In
          </button>
        </nav>
      </div>
    </header>
  );
}
